import { Link } from 'react-router-dom'
import Logo from './Logo.jsx'
import NewsletterForm from './NewsletterForm.jsx'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <Logo light />
          <p>
            Research compounds synthesized for precision. Third-party tested for
            verified purity.
          </p>
          <p className="footer__ro">For research purposes only.</p>
          <div className="footer__news">
            <span className="footer__news-title">Research updates from Renew</span>
            <NewsletterForm />
          </div>
        </div>

        <div className="footer__col">
          <h4>Shop</h4>
          <Link to="/products">All Products</Link>
          <Link to="/products">Featured</Link>
          <Link to="/delivery">Delivery</Link>
        </div>

        <div className="footer__col">
          <h4>Company</h4>
          <Link to="/partner">Partner</Link>
          <Link to="/partner">Quality &amp; Testing</Link>
          <Link to="/partner">Affiliate Program</Link>
          <Link to="/blog">Research Notes</Link>
          <Link to="/faq">FAQ</Link>
        </div>

        <div className="footer__col">
          <h4>Legal</h4>
          <Link to="/research-use-terms">Research Use Only Terms</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/refund-policy">Refund &amp; Returns</Link>
          <Link to="/coas">Certificates of Analysis</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>

      <div className="container footer__disclaimer">
        <h4>Renew</h4>
        <p>
          Renew supplies research-grade compounds for laboratory use. All
          products available on this site are intended strictly for laboratory
          research use only. They are not for human or animal consumption.
          Access to this website and the purchase of any products is restricted
          to individuals 21 years of age or older.
        </p>
      </div>

      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} Renew. All rights reserved.</span>
        <span>
          Products are intended for laboratory research use only and are not for
          human consumption.
        </span>
      </div>
    </footer>
  )
}
